import React from "react";
import RejectionReasons from "../../modules/rejectionReasons";

const RejectionReasonsPage = () => {
  return <RejectionReasons />;
};

export default RejectionReasonsPage;
